import React, { useState } from "react";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";
import logo from "../../assets/A1Tech.png";
import "./navbar.css";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className="gpt3__navbar" data-aos="fade-down">
      <div className="gpt3__navbar-links">
        <div className="gpt3__navbar-links_logo">
          <img src={logo} alt="Logo" width="100%" />
        </div>
        <div className="gpt3__navbar-links_container">
          <p>
            <a href="#home" >
              Home
            </a>
          </p>
          <p>
            <a href="#aboutUs">About us</a>
          </p>
          <p>
            <a href="#projects">Our Startups</a>
          </p>
          <p>
            <a href="#contacts">Contact</a>
          </p>
          {/* <p><a href="#blog">Library</a></p> */}
        </div>
      </div>
      {/* <div className="gpt3__navbar-sign">
        <p>Sign in</p>
        <button type="button">Sign up</button>
      </div> */}
      <div className="gpt3__navbar-menu">
        {toggleMenu ? (
          <RiCloseLine
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(false)}
          />
        ) : (
          <RiMenu3Line
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(true)}
          />
        )}
        {toggleMenu && (
          <div className="gpt3__navbar-menu_container scale-up-center">
            <div className="gpt3__navbar-menu_container-links">
              <p>
                <a href="#home">Home</a>
              </p>
              <p>
                <a href="#aboutUs">About us</a>
              </p>
              <p>
                <a href="#projects">Our Startups</a>
              </p>
              <p>
                <a href="#сontacts">Contact</a>
              </p>
            </div>
            {/* <div className="gpt3__navbar-menu_container-links-sign">
            <p>Sign in</p>
            <button type="button">Sign up</button>
          </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
